import React from "react";
import Layout from "../../Components/Layout/Layout";
import ReactPlayer from "react-player";

const HowToUse = () => {

  return (
    <Layout title="Student Achievements" page="howtouse">
      <div className="m-top-3"><div className="page-title"><h2>How to use</h2></div></div>
      <div className="container px-4">
        <div className="mb-5">
          <h4>1. School Dashboard: Step by Step Walkthrough</h4>
          <ReactPlayer url="https://www.youtube.com/watch?v=gTc6ae1xB9M" controls={true} />
        </div>
        <div className="mb-5">
          <h4>2. KidEx Holistic Development Program: Overview</h4>
          <ReactPlayer url="https://www.youtube.com/watch?v=DxYGBc1oGvI" controls={true} />
        </div>
        <div className="mb-5">
          <h4>3. Testimonials</h4>
          <ReactPlayer url="https://www.youtube.com/watch?v=wKcfsd2Xbpk" controls={true} />
        </div>
      </div>
    </Layout>
  );
};

export default HowToUse;
